export const VitrineBadge = ({ format, testid = 'vitrine-deportee-badge' }) => (format === 'vitrine_deportee' ? (
  <span className="inline-flex items-center rounded-full bg-orange-100 text-orange-700 border border-orange-300 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide whitespace-nowrap" data-testid={testid}>
    Vitrine déportée
  </span>
) : null);
